import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/c54a7b7/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { StructuredListWrapper, StructuredListHead, StructuredListBody, StructuredListRow, StructuredListInput, StructuredListCell, OrderedList, ListItem } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">How it works</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility considerations</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Resources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accessibility testing</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "how-it-works"
    }}>{`How it works`}</h2>
    <p>{`Different List elements are used to add structure to a group of related information. The List Carbon component provides both an ordered list and an unordered list which can contain nested lists. It’s important to understand that different types of lists are used to group information according to its nature to provide orientation for users. Ordered lists are used for sequential information and are automatically enumerated by the browser. Unordered lists are used when the order of the items is not relevant and are marked with bullets.`}</p>
    <h2 {...{
      "id": "accessibility-considerations"
    }}>{`Accessibility considerations`}</h2>
    <p>{`This component has been validated to meet the `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20/"
      }}>{`WCAG 2.0 AA`}</a>{` and `}<a parentName="p" {...{
        "href": "http://www.section508.gov/"
      }}>{`Section 508`}</a>{` accessibility guidelines, however changes made by the content owner can affect accessibility compliance. Be sure to review and follow the guidance in this section when updating or adding new content to this component.`}</p>
    <ol>
      <li parentName="ol">{`Ensure content such as HTML elements and form controls are included using the appropriate Carbon Components and tested for accessibility.`}</li>
      <li parentName="ol">{`Lists should not be used for visual indentation or layout purposes.`}</li>
    </ol>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <p><strong parentName="p">{`Helpful resources for creating customized accessible implementations`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/page-structure/content/"
        }}>{`W3C Content Structure tutorial`}</a>{` covers the usage of lists.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.ibm.com/able/guidelines/ci162/info_and_relationships.html"
        }}>{`IBM Accessibility Checklist - Checkpoint 1.3.1 Info and Relationships`}</a>{` (WCAG Technique `}<a parentName="li" {...{
          "href": "https://www.w3.org/WAI/WCAG21/Techniques/html/H48"
        }}>{`H48`}</a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "accessibility-testing"
    }}>{`Accessibility testing`}</h2>
    <p>{`Accessibility issues are tracked in the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/milestones"
      }}>{`Carbon Component GitHub repository`}</a>{`.`}</p>
    <h3 {...{
      "id": "automated-test"
    }}>{`Automated test`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">
            Automated test environment
          </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />
            - Dynamic Assessment Plugin version 1.8.0.0 - IBM Accessibility WCAG
            2.1 Sept. 2019 Ruleset
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>DAP test</strong>
            <br />- No Violations
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "macos-screen-reader-tests"
    }}>{`macOS Screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Chrome version 77.0.3865.90
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to read the first list item. VO
                announces that there are three items in the list, then reads the
                item number, position, and text.
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to read the next item and VO
                announces you are in another list that contains two items.
              </ListItem>
              <ListItem mdxType="ListItem">
                Continue to navigate to each item using Control-Option-Right
                Arrow and VO announces similar information for each item and
                advises when you reach the end of th nested list and the parent
                list.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - macOS Mojave version 10.14.6 with VoiceOver
            <br />
            - Safari version 13.0.2
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver(VO) test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to read the first list item. VO
                announces that there are three items in the list, then reads the
                item number, position, and text. (Note: Safari displays the
                first list item as 0)
              </ListItem>
              <ListItem mdxType="ListItem">
                Control-Option-Right Arrow to read the next item and VO
                announces you are in another list that contains two items.
              </ListItem>
              <ListItem mdxType="ListItem">
                Continue to navigate to each item using Control-Option-Right
                Arrow and VO announces similar information for each item and
                advises when you reach the end of th nested list and the parent
                list.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "windows-screen-reader-tests"
    }}>{`Windows screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment</StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Firefox version 67
            <br />
            - JAWS 19.1810.64
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate the list with Up and Down Arrow keys.
              </ListItem>
              <ListItem mdxType="ListItem">
                JAWS announces, "The beginning of the list, number of items in
                the list, nesting level, content of the list item, and end of
                list."
              </ListItem>
              <ListItem mdxType="ListItem">
                Information and the list item content are announced on two
                separate lines on the virtual viewer. For example, "List of 2
                itemsnesting level 1. a. Ordered list level 2."
              </ListItem>
              <ListItem mdxType="ListItem">
                Bullets and item numbers are also placed on a separate line.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />
            - JAWS version 19.1810.64
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>JAWS test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate the list with Up and Down Arrow keys.
              </ListItem>
              <ListItem mdxType="ListItem">
                JAWS announces, "The beginning of the list, number of items in
                the list, nesting level, content of the list item, and end of
                list."
              </ListItem>
              <ListItem mdxType="ListItem">
                Information and the list item content are announced on two
                separate lines on the virtual viewer. For example, "List of 2
                itemsnesting level 1. a. Ordered list level 2."
              </ListItem>
              <ListItem mdxType="ListItem">
                Bullets and item numbers are also placed on a separate line.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Microsoft Windows 10
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />
            - NVDA version 2018.4.1
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>NVDA test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate the list with Up and Down Arrow keys.
              </ListItem>
              <ListItem mdxType="ListItem">
                NVDA announces, "The beginning of the list, number of items in
                the list, nesting level, content of the list item, and end of
                list."
              </ListItem>
              <ListItem mdxType="ListItem">
                List item parameters are announced together with the list item
                content. For example, "List with 3 items. 1. Ordered list. Level
                1."
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "android-screen-reader-tests"
    }}>{`Android screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListHead mdxType="StructuredListHead">
        <StructuredListRow head mdxType="StructuredListRow">
          <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
          <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
        </StructuredListRow>
      </StructuredListHead>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - Android version 9 with Talkback
            <br />
            - Chrome version 71.0.3578.98 (Official Build) (64-bit)
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>Talkback test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate list items by swiping left or right, or using the Left
                and Right Arrow keys.
              </ListItem>
              <ListItem mdxType="ListItem">
                Talkback announces, "In list" when entering a list. "Out of
                list" when exiting a list.
              </ListItem>
              <ListItem mdxType="ListItem">
                Talkback also announces entering or exiting nested lists. Number
                of list items, nesteing levels, and content of the list item.
              </ListItem>
              <ListItem mdxType="ListItem">
                Bullets and numbers are announced separately from the list item
                content.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>
    <h3 {...{
      "id": "ios-screen-reader-tests"
    }}>{`iOS screen reader tests`}</h3>
    <Row mdxType="Row">
  <Column noGutterSm mdxType="Column">
    <StructuredListWrapper mdxType="StructuredListWrapper">
      <StructuredListRow head mdxType="StructuredListRow">
        <StructuredListCell head mdxType="StructuredListCell">Environment </StructuredListCell>
        <StructuredListCell head mdxType="StructuredListCell">Results</StructuredListCell>
      </StructuredListRow>
      <StructuredListBody mdxType="StructuredListBody">
        <StructuredListRow mdxType="StructuredListRow">
          <StructuredListCell mdxType="StructuredListCell">
            - iOS version 13.1.3 with VoiceOver
            <br />
            - Safari version 13.1.3
            <br />- Carbon React version 7.7.1
          </StructuredListCell>
          <StructuredListCell mdxType="StructuredListCell">
            <strong>VoiceOver test:</strong>
            <OrderedList mdxType="OrderedList">
              <ListItem mdxType="ListItem">
                Navigate list items by swiping left or right, or using the Left
                and Right Arrow keys on the keyboard when the quick navigation
                is turned on.
              </ListItem>
              <ListItem mdxType="ListItem">
                iOS announces, "The start of the list, nesting level, the
                content of the list item and the end of the list."
              </ListItem>
              <ListItem mdxType="ListItem">
                When navigating the list, "list start" is announced on the
                beginning of the list, and "list end" is announced at the end of
                the list, regardless of the direction we are approaching from.
              </ListItem>
              <ListItem mdxType="ListItem">
                Information about the list, bullets and numbers and list item
                contents are pronounced separately, we have to navigate through
                these one by one.
              </ListItem>
            </OrderedList>
          </StructuredListCell>
        </StructuredListRow>
      </StructuredListBody>
    </StructuredListWrapper>
  </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      